<template>
    <div class="mt-1">
        <b-card>
            <b-row>
                <b-col md="12">
                    <b-form-group
                        :label="$t('Component(ComplianceOverview):column-status')"
                        class="mb-0"
                    >
                        <b-form-select
                            :value="status"
                            :options="statusOptions"
                            @input="$emit('update:status', $event)"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="mt-1">
                <b-col>
                    <b-form-group
                        :label="$t('Component(Label):comment')"
                        class="mb-0"
                    >
                        <b-form-input
                            :value="comment"
                            @input="$emit('update:comment', $event)"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <div class="d-flex justify-content-end mt-1">
            <b-button
                v-if="showCancel"
                variant="outline-secondary"
                class="mr-1"
                @click="$emit('cancel')"
            >
                {{ cancelLabel }}
            </b-button>
            <b-button
                v-if="showSave"
                variant="primary"
                :disabled="saving"
                @click="$emit('save')"
            >
                {{ saveLabel }}
            </b-button>
        </div>
    </div>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BButton,
} from 'bootstrap-vue'

export default {
    name: 'ReviewItemActionsSection',
    components: {
        BCard,
        BRow,
        BCol,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BButton,
    },
    props: {
        status: {
            type: String,
            required: true,
        },
        comment: {
            type: String,
            default: '',
        },
        saving: {
            type: Boolean,
            default: false,
        },
        statusOptions: {
            type: Array,
            default: () => [],
        },
        showCancel: {
            type: Boolean,
            default: true,
        },
        showSave: {
            type: Boolean,
            default: true,
        },
        cancelLabel: {
            type: String,
            default() {
                return this.$t('Component(Button):cancel')
            },
        },
        saveLabel: {
            type: String,
            default() {
                return this.$t('Component(Button):save')
            },
        },
    },
}
</script>
